<template>
  <div class="clearfix com-mod-section-container">
    <h3 class="com-mod-section-header">
      {{ title() }}
    </h3>
    <div class="row">
      <div class="col-md-6">
        <morningstar-ratings />
      </div>
      <div class="col-md-6">
        <risk-measures />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <article v-if="isAuthorizedModule['riskRatingQualitySummary']" id="_riskRatingQualitySummary">
          <quality-summary :quality-data="getQualitySummary" v-if="containsQualitySummaryData" />
        </article>
      </div>
      <div class="col-md-6">
        <article v-if="isAuthorizedModule['riskRatingAverageLife']" id="_riskRatingAverageLife">
          <average-life :avg-life-data="getAvgLifeData" v-if="containsAvgLifeData"/>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AverageLife from '_components_/Modules/AverageLife';
import MorningstarRatings from '_components_/Modules/MorningstarRatings';
import RiskMeasures from '_components_/Modules/RiskMeasures';
import QualitySummary from '_components_/Modules/QualitySummary';

export default {
	components: {
		AverageLife,
		MorningstarRatings,
		RiskMeasures,
		QualitySummary
	},
	computed: {
		...mapGetters([
			'fundObjective',
			'getAvgLifeData',
			'getAverageLifeMaxValue',
			'getQualitySummary'
		]),
		containsAvgLifeData() {
			const data = this.getAvgLifeData
				? [...this.getAvgLifeData]
				: [];
			let result = false;
			data.forEach(subType => {
				if (!isNaN(subType.DataValue)) result = true;
			});
			return result;
		},
		containsQualitySummaryData() {
			const data = this.getQualitySummary
				? [...this.getQualitySummary]
				: [];
			return data.length !== 0;
		}
	},
	methods: {
		title() {
			return this.$store.state.isInstitutional ? 'Portfolio Composition' : 'Ratings & Risk';
		}
	}
};
</script>

<style lang="less" scoped>
	@import '~_css_/module.less';
</style>
